import type { JSX } from 'react';

import { MFormItem } from '../MFormItem/MFormItem';
import { MInput, MInputProps } from '../MInput/MInput';

export interface MFormInputProps extends MInputProps {
  label: string;
  error?: string;
  tooltip?: {
    type: 'modal' | 'popover';
    title: string;
    content: string | JSX.Element;
  };
  size?: 'small' | 'middle' | 'large';
  weight?: 'light' | 'medium';
  align?: 'vertical' | 'horizontal';
  testId?: string;
}

export const MFormInput = ({
  label,
  placeholder,
  value,
  defaultValue,
  error,
  onChange,
  disabled,
  size,
  weight,
  align,
  tooltip,
  addOnBefore,
  addOnAfter,
  className,
  testId,
}: MFormInputProps) => {
  return (
    <MFormItem label={label} tooltip={tooltip} weight={weight} testId={testId} align={align}>
      <MInput
        value={value}
        defaultValue={defaultValue}
        size={size}
        onChange={onChange}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        addOnBefore={addOnBefore}
        addOnAfter={addOnAfter}
        className={className}
        weight={weight}
        testId={testId}
      />
    </MFormItem>
  );
};
